/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState, useCallback } from 'react'
import Loader from '../Loader'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { ADMIN_API } from '../../common/common';
import { postApiAdmin } from '../../service';
import { Logout } from '../../common/Funcation';
import moment from 'moment';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { getTheme } from '../../common/StyleSeter'


let dropdown = [
  { name: 'Settled', value: 'settled' },
  { name: 'Cancelled', value: 'cancelled' },
  { name: 'Voided', value: 'voided' },
]


const CATEGORY_TAB = [
  { name: 'All', value: 'all' },
  { name: 'Exchange', value: 'exchange' },
  { name: 'Fancybet', value: 'fancyBet' },
  { name: 'Bookmaker', value: 'bookMaker' },
  { name: 'Sportsbook', value: 'sportsBook' },
  { name: 'Binary', value: 'binary' },
  { name: 'AWC', value: 'casinoBet' }
]




function CurrentBet(_props) {
  const navigate = useNavigate()
  const [isLoadingMain, setIsLoadingMain] = useState(false)
  const [activeCategory, setActiveCategory] = useState('All')
  const [activeDD, setActiveDD] = useState(false)
  const [during, setDuring] = useState(false)
  const [selectedDropdown, setSelectedDropdown] = useState('Settled')
  const [pageData, setPageData] = useState([])
  const [duringFilter, setDuringFilter] = useState('all');
  const [openBet, setOpenBet] = useState('')
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [showFromCalendar, setShowFromCalendar] = useState(false);
  const [showToCalendar, setShowToCalendar] = useState(false);
  const HeaderData = useSelector((e) => e.Header);
  const userData = useSelector((e) => e.userData);
  const DD = useSelector((e) => e.domainDetails);
  const userId = HeaderData?._id

  const tabsRef = useRef([]);
  const tabsContainerRef = useRef(null);

  const [sliderStyle, setSliderStyle] = useState({
    left: 0,
    width: 0,
  });

  // useEffect(() => {
  //   const tabIndex = activeCategory === 'all' ? 0 : activeCategory === 'exchange' ? 1 : activeCategory === 'bookMark' ? 2 : activeCategory === 'sportsBook' ? 3 : 4;
  //   const currentTab = tabsRef.current[tabIndex];
  //   if (currentTab) {
  //     setSliderStyle({
  //       left: currentTab.offsetLeft,
  //       width: currentTab.offsetWidth,
  //     });
  //   }
  // }, [activeCategory]);

  useEffect(() => {
    const activeTab = tabsRef.current.find(
      (tab) =>
        tab?.textContent?.trim() === activeCategory
    );

    const tabsContainer = tabsContainerRef.current;

    if (!activeTab || !tabsContainer) return;

    const tabRect = activeTab.getBoundingClientRect();
    const containerRect = tabsContainer.getBoundingClientRect();

    setSliderStyle({
      left: tabRect.left - containerRect.left + tabsContainer.scrollLeft,
      width: tabRect.width,
    });

    const tabLeft = activeTab.offsetLeft;
    const tabRight = tabLeft + activeTab.offsetWidth;

    const visibleLeft = tabsContainer.scrollLeft;
    const visibleRight =
      visibleLeft + tabsContainer.clientWidth;

    if (tabLeft < visibleLeft) {
      tabsContainer.scrollTo({
        left: tabLeft - 10,
        behavior: 'smooth',
      });
    } else if (tabRight > visibleRight) {
      tabsContainer.scrollTo({
        left: tabRight - tabsContainer.clientWidth + 10,
        behavior: 'smooth',
      });
    }
  }, [activeCategory]);


  const handleDDselect = (value) => {
    setSelectedDropdown(value)
    setActiveDD(false)
  }

  const getPageData = useCallback(async (dateFilter = 'all', from = null, to = null) => {
    setIsLoadingMain(true)
    let data = {
      api: ADMIN_API.PLAYER_BET_HISTORY,
      value: {
        id: userId ? userId : userData?._id,
        bet: 'history',
        betStatus: dropdown.find((item) => item.name === selectedDropdown)?.value || 'all',
        betType: CATEGORY_TAB.find((item) => item.name === activeCategory)?.value || 'all',
        filter: dateFilter === 'all' ? 'all' : 'date',
        from: from ? moment(from).format('YYYY-MM-DD') : null,
        to: to ? moment(to).format('YYYY-MM-DD') : null,
      },
    }

    await postApiAdmin(data).then(function (response) {
      // console.log(response);
      setPageData(response.data.data.bets ?? [])
      setIsLoadingMain(false)
    }).catch(err => {
      debugger
      if (err.response.data.statusCode === 401) {
        Logout()
        setIsLoadingMain(false)
        navigate('/login')
      }
    })
  }, [activeCategory, selectedDropdown, userId, userData, navigate])

  useEffect(() => {
    // By default fetch today's data
    getPageData('date', fromDate, toDate)
    return () => {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPageData])

  const handleOpenBetAccordian = (value) => {
    if (value === openBet) {
      setOpenBet('')
    }
    else {
      setOpenBet(value)
    }
  }

  // const handleDateSubmit = (filter = duringFilter) => {
  //   let filteredData = [...originalPageData];

  //   // Today
  //   if (filter === 'today') {
  //     filteredData = filteredData.filter((item) =>
  //       moment(item.createdAt).isSame(moment(), 'day')
  //     );
  //     setFromDate(new Date());
  //     setToDate(new Date());
  //   }

  //   // Yesterday
  //   else if (filter === 'yesterday') {
  //     filteredData = filteredData.filter((item) =>
  //       moment(item.createdAt).isSame(
  //         moment().subtract(1, 'day'),
  //         'day'
  //       )
  //     );
  //     setFromDate(moment().subtract(1, 'day').toDate());
  //     setToDate(moment().subtract(1, 'day').toDate());
  //   }

  //   // Last 7 Days
  //   else if (filter === 'last7days') {
  //     filteredData = filteredData.filter((item) =>
  //       moment(item.createdAt).isBetween(
  //         moment().subtract(6, 'days').startOf('day'),
  //         moment().endOf('day'),
  //         undefined,
  //         '[]'
  //       )
  //     );
  //     setFromDate(moment().subtract(6, 'days').startOf('day').toDate());
  //     setToDate(moment().endOf('day').toDate());
  //   }

  //   // Custom Start Date / End Date
  //   else {
  //     const startDate = moment(fromDate).startOf('day');
  //     const endDate = moment(toDate).endOf('day');

  //     filteredData = filteredData.filter((item) =>
  //       moment(item?.createdAt).isBetween(
  //         startDate,
  //         endDate,
  //         undefined,
  //         '[]'
  //       )
  //     );
  //   }

  //   setPageData(filteredData);
  //   setDuring(false);
  // };

  const handleDateSubmit = (filter = duringFilter) => {
    // Today
    if (filter === "today") {
      setFromDate(new Date());
      setToDate(new Date());
      getPageData('date', new Date(), new Date());
    }

    // Yesterday
    else if (filter === "yesterday") {
      const yesterday = moment().subtract(1, "day");
      setFromDate(yesterday.toDate());
      setToDate(yesterday.toDate());
      getPageData('date', yesterday.toDate(), yesterday.toDate());
    }

    // Last 7 Days
    else if (filter === "last7days") {
      const startDate = moment().subtract(6, "days").startOf("day");
      const endDate = moment().endOf("day");
      setFromDate(startDate.toDate());
      setToDate(endDate.toDate());
      getPageData('date', startDate.toDate(), endDate.toDate());
    }

    // Custom date range
    else {
      getPageData('date', fromDate, toDate);
    }

    setDuring(false);
  };

  return (
    <>
      {/* {console.log("pageData", pageData)} */}

      <div className='full-wrap bottomfooter leagues'>
        {isLoadingMain && <div className='loader_top'> <Loader /> </div>}

        <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                    .sports-tab-panel {
                          position: relative;
                      }

                      .sports-tab-scroll {
                          position: relative;
                          width: 100%;
                          overflow-x: auto;
                          overflow-y: hidden;
                          -webkit-overflow-scrolling: touch;
                          scrollbar-width: none;
                      }

                      .sports-tab-scroll::-webkit-scrollbar {
                          display: none;
                      }

                      .sports-tab-list {
                          position: relative;
                          display: inline-flex;
                          align-items: center;
                          flex-wrap: nowrap;
                          list-style: none;
                          width: max-content;
                          min-width: 100%;
                          margin: 0;
                          padding: 0 0 6px 0;
                          box-sizing: border-box;
                      }

                      .sports-tab-panel-item {
                          position: relative;
                          flex: 0 0 auto;
                          cursor: pointer;
                          margin: 0 8px;
                          white-space: nowrap;
                      }

                      .sports-tab-panel-item h3 {
                          margin: 0;
                          padding: 0;
                          font-weight: 700;
                          font-size: 13.52px;
                      }

                      .sports-tab-panel-item.selected h3 {
                          font-weight: 700;
                      }

                      .sports-tab-panel-item.not-selected h3 {
                          font-weight: 700;
                      }

                      .tab-slider {
                          position: absolute;
                          bottom: 0px;
                          height: 4px;
                          background-color: black;
                          border-radius: 10px;

                          transition:
                              left 0.3s ease,
                              width 0.3s ease;

                          pointer-events: none;
                      }
                    .sports-tab-panel-item h3 {
                        margin: 0;
                        padding: 0;
                    }
                    .sports-tab-panel-item.selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .sports-tab-panel-item.not-selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .tab-slider {
                        transition: left 0.3s ease, width 0.3s ease !important;
                        margin: 0;
                        padding: 0;
                    }
                    .custom-calendar {
                        background: white;
                        border: 1px solid #d4e0e5;
                        border-radius: 8px;
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    .custom-calendar .react-datepicker__day--highlighted {
                        background-color: #ffc107 !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__day--selected {
                        background-color: #ffc107 !important;
                        color: white !important;
                        border-radius: 50%;
                    }
                    .custom-calendar .react-datepicker__header {
                        background-color: #f8f9fa;
                        border-bottom: 1px solid #d4e0e5;
                        padding: 0px;
                    }
                    .custom-calendar .react-datepicker__current-month {
                        color: #fff;
                        font-weight: 600;
                        height: 32px;
                        background: ${getTheme(DD?.colorSchema)?.backgroundColor};
                        padding-top: 3px !important;
                    }
                    .custom-calendar .react-datepicker__navigation-icon::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation-icon:hover::before {
                        border-color: white;
                    }
                    .custom-calendar .react-datepicker__navigation {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        border-radius: 4px;
                        width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        top: 0px;
                    }
                    .custom-calendar .react-datepicker__navigation:hover {
                        background-color: ${getTheme(DD?.colorSchema)?.backgroundColor} !important;
                        opacity: 0.8;
                    }
                    .custom-calendar .react-datepicker__day-name {
                        color: #666;
                        font-weight: 500;
                    }
                    .custom-calendar .react-datepicker__day {
                        color: #333;
                    }
                    .custom-calendar .react-datepicker__day:hover {
                        background-color: #e9ecef;
                    }
                    .calendar-dropdown {
                        animation: slideDown 0.3s ease;
                    }
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            max-height: 0;
                            overflow: hidden;
                        }
                        to {
                            opacity: 1;
                            max-height: 500px;
                            overflow: visible;
                        }
                    }
                `}</style>
        <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
          Bets History
          <div className='cross-icon' onClick={() => navigate('/')} />
        </div>

        <div className="pt-0 inner-sidebar-content">
          <div
            className="sports-tab-panel position-relative"
            style={{
              paddingLeft: "0.5rem",
              paddingRight: 0,
              paddingBottom: "0.3rem",
              paddingTop: "0.6rem",
            }}
          >
            <div
              ref={tabsContainerRef}
              className="sports-tab-scroll"
            >
              <ul className="sports-tab-list">
                <li
                  ref={(el) => (tabsRef.current[0] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'All'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('All')}
                >
                  <h3>All</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[1] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Exchange'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Exchange')}
                >
                  <h3>Exchange</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[2] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Fancybet'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Fancybet')}
                >
                  <h3>Fancybet</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[3] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Bookmaker'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Bookmaker')}
                >
                  <h3>Bookmaker</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[4] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Sportsbook'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Sportsbook')}
                >
                  <h3>Sportsbook</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[5] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Binary'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Binary')}
                >
                  <h3>Binary</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[6] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'AWC'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('AWC')}
                >
                  <h3>AWC</h3>
                </li>

                <div
                  className="tab-slider"
                  style={{
                    left: `${sliderStyle.left}px`,
                    width: `${sliderStyle.width}px`,
                  }}
                />
              </ul>
            </div>
          </div>

          <div className="pl-filter">
            <div className="select-container bet-history-dropdown">
              <div className="dropdown">
                <button type="button" onClick={() => setActiveDD(!activeDD)} id="dropdown-basic-button" aria-expanded="false"
                  className={`${activeDD ? 'show' : ''} dropdown-toggle btn btn-primary`} style={{ justifyContent: "start", fontWeight: 700 }}>
                  <span style={{ paddingRight: "8px", fontWeight: 400 }}>Bet Status</span> {selectedDropdown}
                </button>

                <div x-placement="bottom-start" aria-labelledby="dropdown-basic-button" className={`${activeDD ? 'show' : ''} dropdown-menu`} data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-start" style={{ paddingLeft: "87px", paddingRight: "1rem" }}
                >

                  {dropdown.filter((_) => _.name !== selectedDropdown).map((item, i) => {
                    return (
                      <>
                        <a key={i} className="dropdown-item" style={{ padding: 0, height: "31px", fontWeight: 700 }} onClick={() => handleDDselect(item.name)}> {item.name}</a> </>
                    )
                  })}
                </div>
              </div>
              <div className="pl-filter-first p-0 mt-2" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <div className="pl-filter-first-time" style={{ position: 'relative', display: 'flex', justifyContent: "start", alignItems: 'center', gap: '8px', width: "100%" }}>
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"></path>
                    <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"></path>
                  </svg>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                      <span className="text-white truncate" onClick={() => { setShowFromCalendar(!showFromCalendar); setShowToCalendar(false); }} style={{ cursor: 'pointer' }}>
                        {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(fromDate).replace(/\//g, '-')}
                      </span>
                      {showFromCalendar && (
                        <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000, marginTop: '4px' }}>
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => { setFromDate(date); setShowFromCalendar(false); setDuringFilter("custom") }}
                            inline
                            highlightDates={[fromDate]}
                            calendarClassName="custom-calendar"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                      )}
                    </div>
                    <div style={{ position: 'relative', width: "100px", textAlign: "start" }}>
                      <span className="text-white truncate" onClick={() => { setShowToCalendar(!showToCalendar); setShowFromCalendar(false); }} style={{ cursor: 'pointer' }}>
                        {new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(toDate).replace(/\//g, '-')}
                      </span>
                      {showToCalendar && (
                        <div className="calendar-dropdown" style={{ position: 'absolute', top: '100%', left: "-40px", zIndex: 1000, marginTop: '4px' }}>
                          <DatePicker
                            selected={toDate}
                            onChange={(date) => { setToDate(date); setShowToCalendar(false); setDuringFilter("custom") }}
                            inline
                            highlightDates={[toDate]}
                            calendarClassName="custom-calendar"
                            dateFormat="dd-MM-yyyy"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button type="button" className="btn btn-primary" style={{ padding: "0 0.5rem 0 0.5rem", height: "31.5px" }} onClick={() => setDuring(!during)}>···</button>
                <button type="button" className="btn btn-primary" onClick={() => handleDateSubmit()}>Submit</button>
              </div>
            </div>

          </div>

          <div style={{ padding: "1rem 1rem 1rem 1rem" }}>
            {(selectedDropdown === "Settled") && <>
              {pageData?.length > 0 ?
                pageData?.map((item, i) => {
                  return (
                    <div key={i} className="all-bets position-relative" style={{ marginBottom: "7.8px" }}>
                      <div className={`current-bets-table mt-0  ${openBet === i ? 'show' : ''}`} style={{ borderBottom: "none", borderRadius: "0.5rem 0.5rem 0 0" }}>
                        <table className="overflow-hidden bg-white mb-0 odds-table table table-bordered">
                          <thead>
                            <tr>
                              <th colSpan={4} style={{ fontSize: "13.52px", textTransform: "capitalize", textAlign: "center" }}>
                                {item.type}
                                <svg stroke="#5a5e62" fill="#5a5e62" strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                </svg>
                                <span className="master-pass" style={{ paddingLeft: 0 }}>{item.name}</span>
                                <svg stroke="#5a5e62" fill="#5a5e62" strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                </svg>
                                <span className="master-pass" style={{ fontWeight: 400, paddingLeft: 0 }}>{item.betType}</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* <tr className="lay-back">
                              <td colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'} `}>{item.betSide} </span> {item.selection}</td>
                            </tr> */}
                            <tr className="lay-back">
                              <td style={{ fontSize: "12.48px", fontWeight: 700, padding: "6px 11px", textTransform: "capitalize" }} colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`} style={{ fontSize: "13.52px", fontWeight: 700, lineHeight: 2, padding: "6px 10px" }}>{item.betSide} </span> {item.selection}</td>
                            </tr>
                            <tr>
                              <style>
                                {`
                                  td.table-data-header {
                                    font-size: 10.4px !important;
                                  }
                                `}
                              </style>
                              <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                              <td className='table-data-header'>Avg. Odds  <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                              <td className='table-data-header'>Stake (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake.toFixed(2)}</strong></td>
                            </tr>
                            <tr>
                              <style>
                                {`
                                  td.table-data-bet-id {
                                    font-size: 12.48px !important;
                                    padding: 0.25rem 0.5rem  !important;
                                  }
                                `}
                              </style>
                              <td className='table-data-bet-id'>Bet ID</td>
                              <td className='table-data-bet-id' colSpan={2}>{item._id}</td>
                            </tr>
                            <tr>
                              <style>
                                {`
                                  td.table-data-bet-placed {
                                    font-size: 12.48px !important;
                                    padding: 0.25rem 0.5rem  !important;
                                  }
                                `}
                              </style>
                              <td className='table-data-bet-placed'>Bet Placed</td>
                              <td className='table-data-bet-placed' colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</td>
                            </tr>
                            {(item?.profit !== null || "") ? (
                              <tr>
                                <style>
                                  {`
                                  td.table-data-profit {
                                    font-size: 12.48px !important;
                                    padding: 0.25rem 0.5rem !important;
                                  }
                                `}
                                </style>
                                <td className='table-data-profit'>Profit/Loss (PBU)</td>
                                <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit}</td>
                              </tr>
                            ) : ""}
                          </tbody>
                        </table>
                      </div>
                    </div>

                  )
                })

                :

                <div className="no-event-outer">
                  <div className="no-event">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                    </svg>
                    No Event
                  </div>
                </div>

              }
            </>}


            {selectedDropdown === "Cancelled" && <>
              {pageData && pageData?.length > 0 ?
                // pageData?.filter(obj => obj.hasOwnProperty('isMatched'))?.map((item, i) => {
                pageData?.map((item, i) => {
                  return (
                    <>
                      <div key={i} className="all-bets position-relative">
                        <div className={`current-bets-table mt-3  ${openBet === i ? 'show' : ''}`}>
                          <table className="overflow-hidden bg-white mb-0 odds-table table table-bordered">
                            <thead>
                              <tr>
                                <th colSpan={4} style={{ fontSize: "13.52px", textTransform: "capitalize", textAlign: "center" }}>
                                  {item.type}
                                  <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                  </svg>
                                  <span className="master-pass" style={{ paddingLeft: 0 }}>{item.name}</span>
                                  <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                  </svg>
                                  <span className="master-pass" style={{ fontWeight: 400, paddingLeft: 0 }}>{item.betType}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* <tr className="lay-back">
                                <td colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'} `}>{item.betSide} </span> {item.selection}</td>
                              </tr> */}
                              <tr>
                                <td style={{ padding: ".5rem", borderRightWidth: 0 }}>
                                  <div style={{
                                    background: "#d4e0e5",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "99999px",
                                    width: "52px",
                                    height: "30px"
                                  }}>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-header {
                                      font-size: 10.4px !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp}</strong></td>
                                <td className='table-data-header'>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake}</strong></td>
                                <td className='table-data-header'>Profit (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit}</strong></td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-bet-id {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem  !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-bet-id'>Bet ID</td>
                                <td className='table-data-bet-id' colSpan={2}>{item._id}</td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-bet-placed {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem  !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-bet-placed'>Bet Placed</td>
                                <td className='table-data-bet-placed' colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</td>
                              </tr>
                              {(item?.profit !== null || "") ? (
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-profit {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-profit'>Profit/Loss (PBU)</td>
                                  <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit}</td>
                                </tr>
                              ) : ""}
                            </tbody>
                          </table>

                          {openBet === i &&
                            <table className="bets-table mb-0 table" style={{ background: "#e2eaef" }}>
                              <thead>
                                <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} className="pe-0">Bet Taken</th>
                                <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</th>
                              </thead>
                              <tbody>
                                <tr className="lay-back">
                                  <td style={{ fontSize: "12.48px", fontWeight: 700, padding: "6px 11px", textTransform: "capitalize" }} colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`} style={{ fontSize: "13.52px", fontWeight: 700, lineHeight: 2, padding: "6px 10px", color: getTheme(DD?.colorSchema)?.backgroundColor }}>{item.betSide} </span> {item.selection}</td>
                                </tr>
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-header {
                                      font-size: 10.4px !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp}</strong></td>
                                  <td className='table-data-header'>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake}</strong></td>
                                  <td className='table-data-header'>Profit (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit}</strong></td>
                                </tr>
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-profit {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-profit'>Profit/Loss (PBU)</td>
                                  <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit}</td>
                                </tr>
                              </tbody>
                            </table>
                          }

                        </div>
                        <button className={`show-hide-bet  ${openBet === i ? 'arrow-up' : ''}`} onClick={() => handleOpenBetAccordian(i)}>
                          <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
                          </svg>
                        </button>
                      </div>
                    </>
                  )
                })

                :
                <div className="no-event-outer">
                  <div className="no-event">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                    </svg>
                    No Event
                  </div>
                </div>
              }
            </>}

            {selectedDropdown === "Voided" && <>
              {pageData && pageData?.length > 0 ?
                // pageData?.filter(obj => obj.hasOwnProperty('isMatched'))?.map((item, i) => {
                pageData?.map((item, i) => {
                  return (
                    <>
                      <div key={i} className="all-bets position-relative">
                        <div className={`current-bets-table mt-3  ${openBet === i ? 'show' : ''}`}>
                          <table className="overflow-hidden bg-white mb-0 odds-table table table-bordered">
                            <thead>
                              <tr>
                                <th colSpan={4} style={{ fontSize: "13.52px", textTransform: "capitalize", textAlign: "center" }}>
                                  {item.type}
                                  <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                  </svg>
                                  <span className="master-pass" style={{ paddingLeft: 0 }}>{item.name}</span>
                                  <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                                  </svg>
                                  <span className="master-pass" style={{ fontWeight: 400, paddingLeft: 0 }}>{item.betType}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* <tr className="lay-back">
                                <td colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'} `}>{item.betSide} </span> {item.selection}</td>
                              </tr> */}
                              <tr>
                                <td style={{ padding: ".5rem", borderRightWidth: 0 }}>
                                  <div style={{
                                    background: "#d4e0e5",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "99999px",
                                    width: "52px",
                                    height: "30px"
                                  }}>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                    <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-header {
                                      font-size: 10.4px !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp}</strong></td>
                                <td className='table-data-header'>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake}</strong></td>
                                <td className='table-data-header'>Profit (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit}</strong></td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-bet-id {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem  !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-bet-id'>Bet ID</td>
                                <td className='table-data-bet-id' colSpan={2}>{item._id}</td>
                              </tr>
                              <tr>
                                <style>
                                  {`
                                    td.table-data-bet-placed {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem  !important;
                                    }
                                  `}
                                </style>
                                <td className='table-data-bet-placed'>Bet Placed</td>
                                <td className='table-data-bet-placed' colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</td>
                              </tr>
                              {(item?.profit !== null || "") ? (
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-profit {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-profit'>Profit/Loss (PBU)</td>
                                  <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit}</td>
                                </tr>
                              ) : ""}
                            </tbody>
                          </table>

                          {openBet === i &&
                            <table className="bets-table mb-0 table" style={{ background: "#e2eaef" }}>
                              <thead>
                                <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} className="pe-0">Bet Taken</th>
                                <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</th>
                              </thead>
                              <tbody>
                                <tr className="lay-back">
                                  <td style={{ fontSize: "12.48px", fontWeight: 700, padding: "6px 11px", textTransform: "capitalize" }} colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`} style={{ fontSize: "13.52px", fontWeight: 700, lineHeight: 2, padding: "6px 10px", color: getTheme(DD?.colorSchema)?.backgroundColor }}>{item.betSide} </span> {item.selection}</td>
                                </tr>
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-header {
                                      font-size: 10.4px !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp}</strong></td>
                                  <td className='table-data-header'>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake}</strong></td>
                                  <td className='table-data-header'>Profit (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit}</strong></td>
                                </tr>
                                <tr>
                                  <style>
                                    {`
                                    td.table-data-profit {
                                      font-size: 12.48px !important;
                                      padding: 0.25rem 0.5rem !important;
                                    }
                                  `}
                                  </style>
                                  <td className='table-data-profit'>Profit/Loss (PBU)</td>
                                  <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit}</td>
                                </tr>
                              </tbody>
                            </table>
                          }

                        </div>
                        <button className={`show-hide-bet  ${openBet === i ? 'arrow-up' : ''}`} onClick={() => handleOpenBetAccordian(i)}>
                          <svg stroke={getTheme(DD?.colorSchema)?.backgroundColor} fill={getTheme(DD?.colorSchema)?.backgroundColor} strokeWidth="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
                          </svg>
                        </button>
                      </div>
                    </>
                  )
                })

                :
                <div className="no-event-outer">
                  <div className="no-event">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                    </svg>
                    No Event
                  </div>
                </div>
              }
            </>}





            {/* {pageData?.length === 0 &&
              <div className="no-event-outer">
                <div className="no-event">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                  </svg>
                  No Event
                </div>
              </div>
            } */}

          </div>



        </div>
      </div >



      {during && <div className="market-depth-modal">
        <div className="market-title">
          <h4 style={{ fontSize: "14.5749px" }}>During</h4>
          <button type="button" onClick={() => setDuring(false)} className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
            <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.80702 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
        <div className="d-flex justify-content-center align-items-center w-100" style={{ padding: "0 0.5rem 0.5rem 0.5rem", background: "#000" }}>
          <div className="p-2 calendar-button" style={{ background: "#fff", borderRadius: "0.5rem", gap: "0.5rem" }}>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('today'); setDuringFilter("today"); }}>Today</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('yesterday'); setDuringFilter("yesterday"); }}>From Yesterday</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { handleDateSubmit('last7days'); setDuringFilter("last7days"); }}>Last 7 Days</button>
          </div>
        </div>
      </div>}




    </>





  )
}

export default CurrentBet